import { render } from "./MenuActivator.vue?vue&type=template&id=7b7c98bf"
import script from "./MenuActivator.vue?vue&type=script&lang=js"
export * from "./MenuActivator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__